
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.529 20.317s.728-2.923 4.471-2.923c2.979 0 4.521 2.856 4.521 2.856","fill":"none","stroke":"#000","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M3.75 16.5v-1c0-1.703 3.023-3.5 8.5-3.5h9.5c.823 0 1.5.677 1.5 1.5v6.375M12.75 12l1.259-5.544A1.505 1.505 0 0115.48 5.25h3.27c.823 0 1.5.677 1.5 1.5V12","fill":"none","stroke":"#000","stroke-width":"1.5"}}),_c('g',{attrs:{"fill":"none","stroke":"#000","stroke-width":"1.5"}},[_c('circle',{attrs:{"cx":"4.175","cy":"19.875","r":"3.375"}}),_c('path',{attrs:{"d":"M4.175 20.25a.376.376 0 01-.375-.375M4.55 19.875a.376.376 0 01-.375.375M4.175 19.5c.206 0 .375.169.375.375M3.8 19.875c0-.206.169-.375.375-.375"}})]),_c('g',{attrs:{"fill":"none","stroke":"#000","stroke-width":"1.5"}},[_c('circle',{attrs:{"cx":"19.875","cy":"19.875","r":"3.375"}}),_c('path',{attrs:{"d":"M19.875 20.25a.376.376 0 01-.375-.375M20.25 19.875a.376.376 0 01-.375.375M19.875 19.5c.206 0 .375.169.375.375M19.5 19.875c0-.206.169-.375.375-.375"}})]),_c('path',{attrs:{"d":"M10.745 19.525v3.502M10.79 21.112s1.909-.272 1.909-1.91v-1.699","fill":"none","stroke":"#000","stroke-width":"1.5","stroke-miterlimit":"1.5"}})])
          )
        }
      }
    